import ComponentHeadline from "../../utillityComponents/ComponentHeadline";

export default function OrgHome() {
  return (
    <>
    <ComponentHeadline icon="GlobeAltIcon" pagetitle="Organisation" />
    </>
  )
}